export default "__VITE_ASSET__268a36f4__"